import { colors, fonts } from './theme';

const styles = {
  footer: {
    marginTop: '4rem',
    paddingTop: '2rem',
    paddingBottom: '2rem',
    borderTop: `thin solid ${colors.gray200}`,
    textAlign: 'center',
    backgroundColor: colors.background,
  },
  content: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1rem',
  },
  links: {
    display: 'flex',
    justifyContent: 'center',
    gap: '1.5rem',
    flexWrap: 'wrap',
    marginBottom: '1rem',
  },
  link: {
    fontFamily: fonts.heading,
    fontSize: '0.875rem',
    color: colors.midGray,
    textDecoration: 'none',
    backgroundImage: 'none',
    transition: 'color 0.2s ease',
  },
  copyright: {
    fontFamily: fonts.body,
    fontSize: '0.75rem',
    color: colors.midGray,
    marginTop: '1rem',
  },
};

function PortalFooter() {
  return (
    <footer style={styles.footer}>
      <div style={styles.content}>
        <div style={styles.links}>
          <a
            href="https://businessinitiative.org/contact/"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
            onMouseEnter={(e) => (e.target.style.color = colors.darkGray)}
            onMouseLeave={(e) => (e.target.style.color = colors.midGray)}
          >
            Contact Us
          </a>
          <a
            href="https://businessinitiative.org"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
            onMouseEnter={(e) => (e.target.style.color = colors.darkGray)}
            onMouseLeave={(e) => (e.target.style.color = colors.midGray)}
          >
            Main Site
          </a>
        </div>
        <div style={styles.copyright}>
          © {new Date().getFullYear()} Business Initiative. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

export default PortalFooter;

